export default function RequiredDocuments() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-4 text-gray-900">
          即日発行に必要な書類・条件
        </h2>
        <p className="text-center text-gray-600 mb-12">
          スムーズに審査を進めるために事前に準備しましょう
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* 必要書類 */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center">
                <i className="ri-file-list-3-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">必要書類</h3>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">本人確認書類</h4>
                  <p className="text-sm text-gray-700">
                    運転免許証、マイナンバーカード、パスポートなど（いずれか1点）
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">銀行口座情報</h4>
                  <p className="text-sm text-gray-700">
                    引き落とし口座の通帳またはキャッシュカード
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">メールアドレス</h4>
                  <p className="text-sm text-gray-700">
                    審査結果の通知を受け取るために必要
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">電話番号</h4>
                  <p className="text-sm text-gray-700">
                    本人確認の連絡が入る場合があります
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 申込み条件 */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center">
                <i className="ri-user-star-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900">申込み条件</h3>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-arrow-right-circle-fill text-teal-600 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">年齢</h4>
                  <p className="text-sm text-gray-700">
                    18歳以上（高校生を除く）
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="ri-arrow-right-circle-fill text-teal-600 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">安定した収入</h4>
                  <p className="text-sm text-gray-700">
                    本人または配偶者に安定継続収入があること
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="ri-arrow-right-circle-fill text-teal-600 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">日本国内在住</h4>
                  <p className="text-sm text-gray-700">
                    日本国内に住所があること
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <i className="ri-arrow-right-circle-fill text-teal-600 text-xl mt-0.5"></i>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">信用情報</h4>
                  <p className="text-sm text-gray-700">
                    過去に延滞などの金融事故がないこと
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 即日発行のコツ */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
            <i className="ri-lightbulb-flash-line text-amber-500 text-2xl"></i>
            即日発行を成功させるコツ
          </h3>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-teal-600 font-bold">1</span>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">午前中に申し込む</h4>
                <p className="text-sm text-gray-700">
                  審査は営業時間内に行われるため、早い時間帯の申込みがおすすめ
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-teal-600 font-bold">2</span>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">正確な情報を入力</h4>
                <p className="text-sm text-gray-700">
                  入力ミスがあると確認に時間がかかり、即日発行が難しくなります
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-teal-600 font-bold">3</span>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">キャッシング枠は0円に</h4>
                <p className="text-sm text-gray-700">
                  キャッシング枠を希望すると審査が厳しくなる傾向があります
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-teal-600 font-bold">4</span>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 mb-1">電話に出られる状態に</h4>
                <p className="text-sm text-gray-700">
                  本人確認の電話がかかってくる場合があるため、すぐに対応できるように
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
